import React from 'react';

export const ForceStackFieldsContext = React.createContext<boolean>(false);
